import { render } from "./ExhibitionTitle.vue?vue&type=template&id=a133f9e0&scoped=true"
import script from "./ExhibitionTitle.vue?vue&type=script&lang=js"
export * from "./ExhibitionTitle.vue?vue&type=script&lang=js"

import "./ExhibitionTitle.vue?vue&type=style&index=0&id=a133f9e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a133f9e0"]])

export default __exports__